export const API_KEY = 'iukofkIJIUl53#ji%^k34j2££3kofkIJIUl53#%IJ3#%£3';
export const API_LOGIN_URL = 'https://kepithorstudios.com/web_api/login.php';
export const API_REGISTER_URL = 'https://kepithorstudios.com/web_api/register.php';